import axios from 'axios'
import store from '@/store/index.js'
import vm from '@/main.js'
import { Message } from 'element-ui'
import myConfig from '@/common/config.js'
const http = {}

var instance = axios.create({
    headers: { 'Content-Type': 'application/json' },
    timeout: 60000,
    validateStatus(status) {
        switch (status) {
            case 400:
                Message.error('请求出错')
                break
            case 401:
                Message.warning({
                    message: '登录令牌过期，请重新登录'
                })
                vm.$router.push('/')
                store.commit('logout')
                return
            case 403:
                Message.warning({
                    message: '拒绝访问'
                })
                break
                // case 404:
                //     Message.warning({
                //         message: '请求错误,未找到该资源'
                //     })
                //     break
            case 500:
                Message.warning({
                    message: '系统繁忙，请稍后再试'
                })
                break
        }
        return status >= 200 && status < 300
    }
})

var posUrl = url => {
    /* 判断url是否为绝对路径 */
    return /(http|https):\/\/([\w.]+\/?)\S*/.test(url)
}

// 添加请求拦截器
instance.interceptors.request.use(
    function(config) {
        if (!posUrl(config.url) && myConfig.domain) {
            config.url = config.url.startsWith('/') ? config.url : `/${config.url}`
            config.url = `http://${myConfig.domain}${config.url}`
        }
        // 请求头添加token
        if (store.state.userToken) {
            config.headers.Authorization = `Bearer ${store.state.userToken}`
        }
        return config
    },
    function(error) {
        return Promise.reject(error)
    }
)

// 响应拦截器即异常处理
instance.interceptors.response.use(
    response => {
        return response.data
    },
    err => {
        if (err && err.response) {} else {
            err.message = '连接服务器失败'
        }
        // Message.error({
        //     message: err.message
        // })
        return Promise.reject(err.response)
    }
)

// http.get = function(url, options) {
//     let loading
//     if (!options || options.isShowLoading !== false) {
//         loading = document.getElementById('ajaxLoading')
//         loading.style.display = 'block'
//     }
//     return new Promise((resolve, reject) => {
//         instance
//             .get(url, options)
//             .then(response => {
//                 if (!options || options.isShowLoading !== false) {
//                     loading = document.getElementById('ajaxLoading')
//                     loading.style.display = 'none'
//                 }
//                 if (response.code === 1) {
//                     resolve(response.data)
//                 } else {
//                     Message.error({
//                         message: response.msg
//                     })
//                     reject(response.msg)
//                 }
//             })
//             .catch(e => {
//                 console.log(e)
//             })
//     })
// }

// http.post = function(url, data, options) {
//     let loading
//     if (!options || options.isShowLoading !== false) {
//         loading = document.getElementById('ajaxLoading')
//         loading.style.display = 'block'
//     }
//     return new Promise((resolve, reject) => {
//         instance
//             .post(url, data, options)
//             .then(response => {
//                 if (!options || options.isShowLoading !== false) {
//                     loading = document.getElementById('ajaxLoading')
//                     loading.style.display = 'none'
//                 }
//                 if (response.code === 1) {
//                     resolve(response.data)
//                         // resolve()
//                 } else {
//                     Message.error({
//                         message: response.msg
//                     })
//                     reject(response.message)
//                 }
//             })
//             .catch(e => {
//                 console.log(e)
//                 loading = document.getElementById('ajaxLoading')
//                 loading.style.display = 'none'
//             })
//     })
// }
http.get = function(url, params, headers) {
    let options = {}
    if (params) {
        options.params = params
    }
    if (headers) {
        options.headers = headers
    }
    return instance.get(url, options)
}
http.post = function(url, params, headers) {
    let options = {}
    if (headers) {
        options.headers = headers
    }
    return instance.post(url, params, options)
}
http.put = function(url, params, headers) {
    let options = {}
    if (headers) {
        options.headers = headers
    }
    return instance.put(url, params, options)
}

export default http